angular.module('powerOfAttorney')
    .component('powerOfAttorneyBtnOptions', {
        bindings: {
            item: '<',
            largeButton: '<'
        },
        templateUrl: 'app/power-of-attorney/_btn-options.html',
        controller: function ($rootScope, PowerOfAttorneyService, Principal, FilesSimpleUploadService, FilesLibrary, PowerOfAttorneyConst) {
            this.PowerOfAttorneyService = PowerOfAttorneyService
            this.FilesLibrary = FilesLibrary
            this.FilesSimpleUploadService = FilesSimpleUploadService

            this.fileResourceName = 'POWER-OF-ATTORNEY';

            this.$onChanges = () => {
                this.isManager = Principal.hasAnyAuthority(["ROLE_POWER_OF_ATTORNEY_ALL"]);
                this.canDelete = true;
                Principal.currentUser().then(user => {
                    this.canEdit = this.isManager || true;
                    this.canManageFiles = this.isManager || true;
                })
            }

            this.attachFile = () => FilesSimpleUploadService.open({type: this.fileResourceName, id: this.item.id}).then(() => $rootScope.$broadcast(PowerOfAttorneyConst.eventUpdate));
            this.attachLibraryFile = () => FilesLibrary.openAndBind({type: this.fileResourceName, id: this.item.id}).then(() => $rootScope.$broadcast(PowerOfAttorneyConst.eventUpdate));
        }
    })
